import React from 'react'
import { useEffect, useState } from 'react'
import Plot from 'react-plotly.js'

function Chart({ data, layout, config }) {
    return (
        <Plot
            data={data}
            layout={layout}
            config={config} 
            useResizeHandler/>
    )
}

export default Chart
